/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';
import type { ShipPositionMmsiGet200ResponseShip } from './ShipPositionMmsiGet200ResponseShip';
import {
    ShipPositionMmsiGet200ResponseShipFromJSON,
    ShipPositionMmsiGet200ResponseShipFromJSONTyped,
    ShipPositionMmsiGet200ResponseShipToJSON,
} from './ShipPositionMmsiGet200ResponseShip';

/**
 * 
 * @export
 * @interface ShipPositionMmsiGet200Response
 */
export interface ShipPositionMmsiGet200Response {
    /**
     * 
     * @type {GeoJson}
     * @memberof ShipPositionMmsiGet200Response
     */
    position?: GeoJson;
    /**
     * 
     * @type {ShipPositionMmsiGet200ResponseShip}
     * @memberof ShipPositionMmsiGet200Response
     */
    ship?: ShipPositionMmsiGet200ResponseShip;
    /**
     * Navigational status as indicated by the AIS information.
     * @type {number}
     * @memberof ShipPositionMmsiGet200Response
     */
    navstatus?: number;
    /**
     * Heading in degrees 0..359
     * @type {number}
     * @memberof ShipPositionMmsiGet200Response
     */
    heading?: number;
    /**
     * Rate of Turn as indicated by the AIS message -127..127
     * @type {number}
     * @memberof ShipPositionMmsiGet200Response
     */
    rot?: number;
}

/**
 * Check if a given object implements the ShipPositionMmsiGet200Response interface.
 */
export function instanceOfShipPositionMmsiGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionMmsiGet200ResponseFromJSON(json: any): ShipPositionMmsiGet200Response {
    return ShipPositionMmsiGet200ResponseFromJSONTyped(json, false);
}

export function ShipPositionMmsiGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionMmsiGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'position': !exists(json, 'position') ? undefined : GeoJsonFromJSON(json['position']),
        'ship': !exists(json, 'ship') ? undefined : ShipPositionMmsiGet200ResponseShipFromJSON(json['ship']),
        'navstatus': !exists(json, 'navstatus') ? undefined : json['navstatus'],
        'heading': !exists(json, 'heading') ? undefined : json['heading'],
        'rot': !exists(json, 'rot') ? undefined : json['rot'],
    };
}

export function ShipPositionMmsiGet200ResponseToJSON(value?: ShipPositionMmsiGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'position': GeoJsonToJSON(value.position),
        'ship': ShipPositionMmsiGet200ResponseShipToJSON(value.ship),
        'navstatus': value.navstatus,
        'heading': value.heading,
        'rot': value.rot,
    };
}

